
import { Options, Vue } from 'vue-class-component'

@Options({
    name: 'good-road-timer-icon'
})
export default class GoodRoadTimerIcon extends Vue { }
